import React from 'react';
import cx from 'classnames';
import Tooltip from 'components/tooltip';

class Item extends React.Component {
  toggle = () => this.props.toggle(this.props.item);

  checkbox = () => {
    var classes = ['fa', 'pull-right', 'component-toggle'];
    if (this.props.item.selected) {
      classes = cx(classes, 'fa-check-square-o');
    } else {
      classes = cx(classes, 'fa-square-o', 'color-secondary');
    }
    return <i className={classes} onClick={this.toggle} />;
  };

  tooltip_description() {
    const classes = ['tooltip-base'];
    if (this.props.showTooltipDescription && this.props.item.description) {
      return (
        <Tooltip className={cx(classes)} title={this.props.item.description}>
          ?
        </Tooltip>
      );
    }
    return null;
  }

  render() {
    var classes = ['grouped-item', 'border-color', this.props.className];
    if (this.props.item.selected) classes.push('active');

    return (
      <div className={cx(classes)}>
        <span>{this.props.item.name}</span>
        {this.tooltip_description()}
        <span style={{ display: 'none' }}>{this.props.item.id}</span>
        {this.checkbox()}
      </div>
    );
  }
}

export default Item;
